import { UseQueryOptions, useQueries, useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';

import { crmScreenerApiClient } from '@/adapters/schemaClients';
import { GetFacilitySettings200Response } from '@/types/crm-screener-api';

const FACILITY_SETTINGS_QUERY_KEY = 'screenerFacilitySettings';

export const useFacilitySettingsQuery = () => {
  return {
    useGetFacilitySettings: (
      facilityId: string,
      options: UseQueryOptions<
        GetFacilitySettings200Response['data'],
        HTTPError
      > = {}
    ) =>
      useQuery<GetFacilitySettings200Response['data'], HTTPError>(
        [FACILITY_SETTINGS_QUERY_KEY, facilityId],
        async () => {
          const response = await crmScreenerApiClient.getFacilitySettings({
            facilityId: facilityId
          });
          return response.data;
        },
        {
          enabled: !!facilityId,
          ...options
        }
      )
  };
};

export const useFacilitySettingsQueries = (facilityIds: string[]) => {
  return useQueries({
    queries: facilityIds.map((facilityId) => ({
      queryKey: [FACILITY_SETTINGS_QUERY_KEY, facilityId],
      queryFn: async () => {
        const response = await crmScreenerApiClient.getFacilitySettings({
          facilityId
        });
        return response.data;
      },
      enabled: !!facilityId
    }))
  });
};
